<div
  *ngIf="control"
  class="form-group inline"
  [class.required]="isRequired"
  [formGroup]="parentForm"
>
  <mat-form-field
    [floatLabel]="'always'"
    appearance="fill"
    [class.readonly]="readOnlyCss"
    [class.long-title]="longTitle"
  >
    <mat-label>{{ title}}</mat-label>

    <input
      matInput
      appTrim
      type="text"
      mask="00000"
      [validation]="false"
      [class.is-invalid]="control.invalid && control.touched"
      class="form-control form-control-sm"
      [formControlName]="formControlName"
    />

    <span
      class="success-mark"
      *ngIf="control.value && !control.errors && !control.hideSuccessMark"
    >
      <fa-icon [icon]="faCheck"></fa-icon>
    </span>
  </mat-form-field>
</div>
